import { PcRevampType } from '../../../shared/types/live-class-locked-state-keys';
import { LiveClassDto } from '../../../shared/types/LiveClassDto';
import { ClassTile } from './class-tile';

export class FutureClassTile extends ClassTile {
  constructor(pcRevampType: PcRevampType, liveClass: LiveClassDto) {
    super(pcRevampType, liveClass);
  }

  onTileClick(): void {
    if (!this.liveClass) {
      return;
    }
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/live-class-section/class-tile/future-class-tile.ts